const { IntrospectionFragmentMatcher } = require('apollo-cache-inmemory');
const introspectionQueryResultData = require('./fragmentTypes');

/**
 * Get the GraphQL fragment matcher
 * @memberof module:@sm/utils
 * @returns {IntrospectionFragmentMatcher} IntrospectionFragmentMatcher
 */
function getGraphQLFragmentMatcher() {
  return new IntrospectionFragmentMatcher({
    introspectionQueryResultData
  });
}

module.exports = getGraphQLFragmentMatcher;
